/* eslint-disable import/prefer-default-export */
export const updateArrayObj = (
  arr,
  item,
  { uniqueIdentifier = 'id', moveItemToTop } = {},
) => {
  if (!item) return arr;
  if (!arr?.length) return [item];
  if (moveItemToTop === undefined)
    return arr.map(v => {
      if (v[uniqueIdentifier] === item[uniqueIdentifier]) return item;
      return v;
    });
  const arrWithoutItem = arr.filter(
    v => v[uniqueIdentifier] !== item[uniqueIdentifier],
  );
  if (moveItemToTop) return [item, ...arrWithoutItem];
  return [...arrWithoutItem, item];
};

export function arrayContainsArray(superset, subset) {
  return subset.every(function(value) {
    return superset.indexOf(value) >= 0;
  });
}
